import PropTypes from 'prop-types'

/**
 * Interface for hotel/item objects in the DynamicInvoice component
 */
export const HotelItemShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  taxRate: PropTypes.number.isRequired
})

/**
 * Props interface for the DynamicInvoice component
 */
export const DynamicInvoicePropTypes = {
  /** Invoice details object passed to child components */
  invoiceDetails: PropTypes.object,
  /** Tax rate percentage (default: 9.5) */
  taxRate: PropTypes.number,
  /** Messages with additional charges data */
  messagesWithAdditionalCharges: PropTypes.object,
  /** Initial start date for billing period (YYYY-MM-DD format) */
  initialStartDate: PropTypes.string,
  /** Initial end date for billing period (YYYY-MM-DD format) */
  initialEndDate: PropTypes.string,
  /** Initial invoice date (YYYY-MM-DD format) */
  initialInvoiceDate: PropTypes.string,
  /** Initial new charges on date (YYYY-MM-DD format) */
  initialNewChargesOn: PropTypes.string,
  /** Initial invoice ID */
  initialInvoiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Initial list of hotel/item entries */
  initialHotels: PropTypes.arrayOf(HotelItemShape)
}

export const DynamicInvoiceDefaultProps = {
  taxRate: 9.5,
  initialStartDate: null,
  initialEndDate: null,
  initialInvoiceDate: null,
  initialNewChargesOn: null,
  initialInvoiceId: '',
  initialHotels: []
}

